// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cv-option, .cv-option-created {
  padding: 8px;
  cursor: pointer;
  margin-bottom: 5px;
}

.cv-option-created {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}`, "",{"version":3,"sources":["webpack://./../common/src/Components/CustomViewCanvas/LeftSideBarCustomViewCanvas.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,eAAA;EACA,kBAAA;AACJ;;AAEA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;AACJ","sourcesContent":[".cv-option, .cv-option-created {\n    padding: 8px;\n    cursor: pointer;\n    margin-bottom: 5px;\n}\n\n.cv-option-created {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
